<template>
    <div v-if="ready">
        <button @click="handleImprimir" class="btn btn-primary mt-5 ms-3" style="color: aliceblue;">Generar Excel <i
                class="fa-solid fa-download"></i></button>
    </div>
    <div class="container d-flex justify-content-center align-items-center text-center">
        <div style="overflow-x: auto; width: 100%;">
            <table class="table table-striped table-hover text-center" id="myTable">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th class="text-center">Beneficiario</th>
                        <!-- <th class="text-center">DNI</th> -->
                        <th>Comentario</th>
                        <th>Tipo Gestión</th>
                        <!-- <th>No Prestamo</th> -->
                        <th>Usuario</th>
                    </tr>
                </thead>
                <tbody v-if="ready">
                    <tr v-for="actividad in bitacora" :key="actividad.id">
                        <td>{{ actividad.id }}</td>
                        <td>{{ actividad.cliente }}</td>
                        <!-- <td>{{ actividad.dni }}</td> -->
                        <td>
                            <div
                                style="white-space: normal; word-break: break-word; max-width: 300px; text-align: justify;">
                                {{ actividad.comentario }}
                            </div>
                        </td>
                        <td>{{ actividad.tipoGestion }}</td>
                        <!-- <td>{{ actividad.noPrestamo }}</td> -->
                        <td>{{ actividad.nombreUsuario }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="10" class="text-center">
                            <div class="spinner-border text-warning text-center" role="status">
                                <span class="visually-hidden text-center">Loading...</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";
import DataTables from "datatables.net";
import ExcelJS from "exceljs";


export default {
    data() {
        return {
            ready: false,
            bitacora: [],
            moneda: "lps",
            imgPath: process.env.VUE_APP_IMAGE_URL,
            totalMontoPagado: 0,
            pago: {
                slug: ''
            }
        }
    },
    props: {
        startDate: new Date,
        endDate: new Date,
        option: Boolean,
    },
    watch: {
        startDate: function () {
            // console.log('date', date)
            this.getPagosByRange()
        },
        endtDate: function () {
            // console.log('date', date)
            this.getPagosByRange()
        }
    },
    beforeMount() {

        this.getBitacoraByRange()
    },
    updated() {
        if (this.ready) {
            this.initializeDataTable();
        }


    },
    methods: {

        getBitacoraByRange() {
            this.ready = false

            let payload = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            fetch(process.env.VUE_APP_API_URL + `/admin/bitocara/allByRange`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            position: 'top-end',
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });

                    } else {

                        this.bitacora = response.data.bitacora;
                        this.ready = true
                        console.log('Bitacora:', response);
                        // this.calculateTotalMonto()

                    }
                })
                .catch(error => {
                    Swal.fire({
                        position: 'top-end',
                        icon: "error",
                        title: error,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                });
        },

        initializeDataTable() {
            console.log('Despues Iniciar');
            const myTable = document.querySelector("#myTable");
            if (myTable) {
                new DataTables(myTable);
            }


        },

        formatoNumero(numero) {
            return new Intl.NumberFormat("en-US").format(numero)
        },
        formatoNumero2(numero) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(numero);
        },

        dateFormat(param) {

            var fechaISO = param;


            // Crear un objeto Date con la fecha proporcionada
            var fecha = new Date(fechaISO);

            // Obtener el día del mes (agregando un cero inicial si es necesario)
            var dia = ('0' + fecha.getUTCDate()).slice(-2);

            // Obtener el mes (agregando un cero inicial si es necesario)
            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

            // Obtener el año
            var anio = fecha.getUTCFullYear();

            // Formatear la fecha según tus necesidades
            var fechaFormateada = dia + '/' + mes + '/' + anio;


            return fechaFormateada;

        },
        pagoSlug(slug) {
            this.pago.slug = slug
        },

        handleImprimir() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Bitácora");

            worksheet.columns = [
                { header: "ID", key: "id", width: 10 },
                { header: "Beneficiario", key: "cliente", width: 30 },
                { header: "DNI", key: "dni", width: 20 },
                { header: "Comentario", key: "comentario", width: 60 },
                { header: "Tipo Gestión", key: "tipoGestion", width: 20 },
                { header: "No Préstamo", key: "noPrestamo", width: 20 },
                { header: "Fecha Promesa", key: "fechaPromesa", width: 20 },
                { header: "Monto Promesa", key: "montoPromesa", width: 20 },
                { header: "Creado por:", key: "usuario", width: 20 },
                { header: "Fecha Creación", key: "creado", width: 20 },
            ];

            worksheet.getRow(1).font = { bold: true };

            const data = this.bitacora.map((item) => ({
                id: item.id,
                cliente: item.cliente,
                dni: item.dni,
                comentario: item.comentario,
                tipoGestion: item.tipoGestion,
                noPrestamo: item.noPrestamo,
                fechaPromesa: this.dateFormat(item.fechaPromesa),
                montoPromesa: item.montoPromesa,
                usuario: item.nombreUsuario,

                creado: this.dateFormat(item.createdAt),
            }));

            worksheet.addRows(data);

            worksheet.getColumn('fechaPromesa').numFmt = 'dd/mm/yyyy';

            worksheet.addTable({
                name: 'BitacoraTable',
                ref: 'A1',
                headerRow: true,
                style: {
                    theme: 'TableStyleMedium2',
                    showRowStripes: true,
                },
                columns: worksheet.columns.map(col => ({ name: col.header, filterButton: true })),
                rows: data.map(row => worksheet.columns.map(col => row[col.key])),
            });

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", `Bitacora-${this.dateFormat(this.startDate)}-${this.dateFormat(this.endDate)}.xlsx`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        }


    },

}
</script>

<style scoped>
.modal-img> :not(caption)>*>* {
    padding: 0.5rem 0.5rem;
    background-color: white;
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.imagen-recibo {
    width: 100%;
}

button {
    margin-top: 0;
}

.table {
    min-width: 1000px;
}

td {
    vertical-align: middle;
}
</style>